<template>
  <b-card no-body>
    <b-card-header class="p-1">
      <h4 class="mb-0">POS Statistics</h4>
      <div class="d-flex align-items-center" style="width: 250px">
        <feather-icon icon="CalendarIcon" size="16" />
        <flat-pickr
          v-model="rangeDate"
          :config="config"
          class="form-control flat-picker bg-transparent border-0 shadow-none cursor-pointer"
          :placeholder="$t('Select Date')"
          @on-change="setDate"
        />
      </div>
    </b-card-header>

    <!-- Search Filter -->
    <b-card-body class="px-1 pb-1">
      <b-row>
        <b-col md="12" class="d-flex flex-wrap" style="gap: 1rem">
          <div
            class="d-flex align-items-center p-50 rounded cursor-pointer pos-stats-card stats-orders"
          >
            <div
              class="d-flex justify-content-center align-items-center rounded bg-white stats-icon-box"
            >
              <feather-icon
                icon="FileTextIcon"
                size="20"
                class="text-primary"
              />
            </div>
            <div class="ml-1">
              <div
                class="font-medium-2 font-weight-bold line-height-1 stats-orders__value"
              >
                {{ statsObj.orderCount }}
              </div>
              <div class="font-small-3 font-weight-bold stats-orders__label">
                Orders
              </div>
            </div>
          </div>

          <div
            class="d-flex align-items-center p-50 rounded cursor-pointer pos-stats-card stats-amount"
          >
            <div
              class="d-flex justify-content-center align-items-center rounded bg-white stats-icon-box"
            >
              <feather-icon
                icon="TrendingUpIcon"
                size="20"
                class="text-success"
              />
            </div>
            <div class="ml-1">
              <div
                class="font-medium-2 font-weight-bold line-height-1 stats-amount__value"
              >
                {{ statsObj.totalRcvd }}
              </div>
              <div class="font-small-3 font-weight-bold stats-amount__label">
                Amount
              </div>
            </div>
          </div>
        </b-col>
        <!-- <b-col md="12">
          <b-form-input
            v-model.trim="searchQuery"
            placeholder="Search by category..."
          />
        </b-col> -->
      </b-row>
    </b-card-body>

    <!-- sticky-header="350px" -->
    <b-table
      class="mb-0"
      sticky-header="450px"
      show-empty
      :items="filteredItems"
      :fields="fields"
      responsive
      :busy="loading"
    >
      <template #table-busy>
        <div class="text-center my-3">
          <b-spinner
            style="width: 3rem; height: 3rem"
            type="grow"
            variant="primary"
            label="Loading"
          ></b-spinner>
        </div>
      </template>

      <template #cell(category)="data">
        <b-badge variant="light-primary">
          {{ data.item.categoryName }}
        </b-badge>
      </template>

      <template #cell(amount)="data">
        <b-badge variant="light-primary">
          {{ data.item.totalRcvd }}
        </b-badge>
      </template>
    </b-table>
  </b-card>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardBody,
  BTable,
  BBadge,
  BSpinner,
  BFormInput,
  BRow,
  BCol,
} from "bootstrap-vue";
import flatPickr from "vue-flatpickr-component";
import { mapActions } from "vuex";

export default {
  name: "HomeworkCard",
  components: {
    BCard,
    BCardHeader,
    BCardBody,
    BTable,
    BBadge,
    BSpinner,
    BFormInput,
    BRow,
    BCol,
    flatPickr,
  },
  props: {
    campusID: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      searchQuery: "",
      config: {
        mode: "range",
        altFormat: "j M, Y",
        altInput: true,
        dateFormat: "Y-m-d",
      },
      rangeDate: "",
      dateObj: {
        dtFrom: null,
        dtTo: null,
      },
      statsObj: {
        orderCount: 0,
        totalRcvd: 0,
      },
      loading: false,
      items: [],
      fields: [
        { key: "category", label: "category" },
        { key: "amount", label: "amount" },
      ],
    };
  },
  computed: {
    filteredItems() {
      if (!this.searchQuery) return this.items;
      const query = this.searchQuery.toLowerCase();
      return this.items.filter((item) =>
        item.categoryName.toLowerCase().includes(query)
      );
    },
  },
  created() {
    const dt = new Date().toJSON().split("T")[0];
    this.dateObj.dtFrom = dt;
    this.dateObj.dtTo = dt;
    this.rangeDate = `${this.dateObj.dtFrom} to ${this.dateObj.dtTo}`;
    this.LoadData();
  },
  methods: {
    ...mapActions({ get: "get" }),

    setDate(sd, dateStr) {
      // console.log(sd, dateStr);
      if (dateStr) {
        if (sd.length > 1) {
          let date = dateStr.split(" to ");
          if (date.length == 1) {
            this.dateObj.dtFrom = date[0];
            this.dateObj.dtTo = date[0];
          } else {
            this.dateObj.dtFrom = date[0];
            this.dateObj.dtTo = date[1];
          }
          this.LoadData();
        } else {
          this.dateObj.dtFrom = dateStr;
          this.dateObj.dtTo = null;
        }
      } else {
        this.dateObj.dtFrom = null;
        this.dateObj.dtTo = null;
      }
    },

    async LoadData() {
      if (this.dateObj.dtFrom && this.dateObj.dtTo) {
        this.loading = true;
        const obj = {
          url:
            this.$store.state.domain +
            "posOrders/Stats?db=" +
            this.$store.state.userData.db +
            "&campusID=" +
            this.campusID +
            "&dateFrom=" +
            this.dateObj.dtFrom +
            "&dateTo=" +
            this.dateObj.dtTo,
          token: this.$store.state.userData.token,
        };
        const response = await this.get(obj);
        // console.log(response);
        this.items = response?.categoryStats || [];
        this.statsObj = {
          orderCount: response?.orderCount || 0,
          totalRcvd: response?.totalRcvd || 0,
        };

        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@core/scss/vue/libs/vue-flatpicker.scss";

.pos-stats-card {
  box-shadow: 0 4px 6px 0 rgba(34, 41, 47, 0.15);
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-3px);
  }
}
.stats-amount {
  background: #e5fae7;

  &__value {
    color: #3c4d35;
  }

  &__label {
    color: #6e9176;
    letter-spacing: 1;
  }
}
.stats-orders {
  background: #dad7f5;

  &__value {
    color: #27253a;
  }

  &__label {
    color: #695fb6;
    letter-spacing: 1;
  }
}
.stats-icon-box {
  width: 35px;
  height: 35px;
}
</style>
